"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.US_TERRITORIES = void 0;
exports.US_TERRITORIES = ['AS', 'GU', 'MP', 'PR', 'UM', 'VI'];
//# sourceMappingURL=index.js.map